import { useMemo, useState } from "react";
import "./FloatingYoutube.css";

type FloatingYoutubeProps = {
  videoId: string;
  autoPlay?: boolean;
  muted?: boolean;
  startSeconds?: number;
  onClose?: () => void;
};

const FloatingYoutube = ({
  videoId,
  autoPlay = false,
  muted = true,
  startSeconds,
  onClose,
}: FloatingYoutubeProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const src = useMemo(() => {
    const params = new URLSearchParams();
    params.set("autoplay", autoPlay ? "1" : "0");
    params.set("mute", muted ? "1" : "0");
    if (typeof startSeconds === "number") {
      params.set("start", String(startSeconds));
    }

    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
  }, [autoPlay, muted, startSeconds, videoId]);

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();
  };

  return (
    <div className="floatingYoutube">
      <div className="floatingYoutube__header">
        <span className="floatingYoutube__header-text">Watch Our Tutorial</span>
        <button
          type="button"
          className="floatingYoutube__close"
          aria-label="Close video"
          onClick={handleClose}
        >
          ×
        </button>
      </div>
      <iframe
        className="floatingYoutube__iframe"
        src={src}
        title="Promo video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
};

export default FloatingYoutube;
